export const WEB_FRONTEND_NITRO_CLIENT_ID = "Q2xpZW50CmcwMTlhNGU4OTNjZTA3NjVhOTlmNTFlNWZmOTk3MjYyMg=="

export const createGraphQLClientHeaders = (clientVersion: string) => ({
  "GraphQL-Client-Id": WEB_FRONTEND_NITRO_CLIENT_ID,
  "GraphQL-Client-Version": clientVersion,
})
